module.exports = __webpack_public_path__ + "img/Villa_Borna_55.08c561a9.jpg";